// extracted by mini-css-extract-plugin
export default {"arrowButton":"ArrowButton_arrowButton__lONhT","right":"ArrowButton_right__-w9LD","left":"ArrowButton_left__3d8mG"};